export const mockTransactions = [
  { id: 1, date: '2024-04-01', category: 'Food', amount: 500, type: 'expense', description: 'Lunch at restaurant' },
  { id: 2, date: '2024-04-01', category: 'Salary', amount: 50000, type: 'income', description: 'Monthly salary' },
  { id: 3, date: '2024-04-02', category: 'Travel', amount: 1200, type: 'expense', description: 'Uber rides' },
  { id: 4, date: '2024-04-02', category: 'Shopping', amount: 3500, type: 'expense', description: 'Clothes' },
  { id: 5, date: '2024-04-03', category: 'Bills', amount: 8000, type: 'expense', description: 'Rent' },
  { id: 6, date: '2024-04-03', category: 'Food', amount: 800, type: 'expense', description: 'Groceries' },
  { id: 7, date: '2024-04-04', category: 'Entertainment', amount: 1500, type: 'expense', description: 'Movie and dinner' },
  { id: 8, date: '2024-04-04', category: 'Freelance', amount: 12000, type: 'income', description: 'Project payment' },
  { id: 9, date: '2024-04-05', category: 'Food', amount: 300, type: 'expense', description: 'Coffee and snacks' },
  { id: 10, date: '2024-04-05', category: 'Healthcare', amount: 2000, type: 'expense', description: 'Doctor visit' },
];

export const categories = [
  'Food', 'Travel', 'Shopping', 'Bills', 'Entertainment', 'Healthcare', 'Salary', 'Freelance', 'Investment', 'Other'
];

export const monthlyData = [
  { month: 'Jan', income: 62000, expenses: 35000 },
  { month: 'Feb', income: 62000, expenses: 38000 },
  { month: 'Mar', income: 75000, expenses: 42000 },
  { month: 'Apr', income: 62000, expenses: 28000 },
];
